import { useNavigate } from 'react-router-dom';
import { ShieldOff } from 'lucide-react';
import { useWarehouseStore } from '@/stores/warehouse-store';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';

export function AccessDeniedPage() {
  const navigate = useNavigate();
  const selectedWarehouse = useWarehouseStore((s) => s.selectedWarehouse);
  const selectedWarehouseId = useWarehouseStore((s) => s.selectedWarehouseId);
  const accessibleWarehouses = useWarehouseStore((s) => s.accessibleWarehouses);

  // Fall back to the accessible-warehouses list when the full warehouse object
  // hasn't been loaded yet (only the selectedWarehouseId is available then).
  const warehouseName =
    selectedWarehouse?.name ??
    accessibleWarehouses.find((w) => w.warehouseId === selectedWarehouseId)
      ?.warehouseName ??
    'your current warehouse';

  return (
    <div
      className="flex h-[calc(100vh-8rem)] items-center justify-center"
      data-testid="access-denied-page"
    >
      <Card className="mx-auto max-w-md">
        <CardContent className="flex flex-col items-center gap-4 py-12 text-center">
          <div className="rounded-full bg-destructive/10 p-4">
            <ShieldOff className="h-10 w-10 text-destructive" />
          </div>

          <h2 className="text-2xl font-semibold">Access Denied</h2>

          <p className="text-muted-foreground">
            You don't have permission to access this page.
          </p>
          <p className="text-sm text-muted-foreground">
            Your role at <span className="font-medium">{warehouseName}</span>{' '}
            does not include access to this area.
          </p>

          <Button className="mt-2" onClick={() => navigate('/')}>
            Go to Dashboard
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}

export default AccessDeniedPage;
